// generated from 49 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const landingPageRetargetFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("landing_page_retarget_filter"),
  comparison_key: z.enum([
    "7", // 46 (93.88%)
    "8", // 3 (6.12%)
  ]),
  display_name: z.string(),
  // undefined: 5 (10.20%), defined 44 (89.80%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(false),
});
